import { Node, mergeAttributes } from '@tiptap/core';

export const DefinitionList = Node.create({
  name: 'definitionList',
  group: 'block',
  content: '(definitionTerm definitionDescription)+', // allow repeating term-description pairs
  parseHTML() {
    return [{ tag: 'dl' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['dl', mergeAttributes(HTMLAttributes), 0];
  },
});
